import request from '@/router/axios';

const withTruckInboundType = (row = {}) => {
    return { businessType: 3, ...row }
}

export const selectTruckTotalByPoundPage = (row) => {
    return request({
        url: '/api/produce/out-in-stock-record/selectTruckTotalByPoundPage',
        method: 'post',
        data: withTruckInboundType(row)
    })
}
// 过车明细
export const weightPlan = (row, query) => {
    return request({
        url: '/api/produce/out-in-stock-record/select/page',
        method: 'post',
        data: withTruckInboundType({ ...row, ...query })
    })
}
export const shipAmountTotal = (row) => {
    return request({
        url: '/api/produce/out-in-stock-record/select/shipAmountTotal',
        method: 'post',
        data: withTruckInboundType(row)
    })
}

export const transportPlanPage = (row) => {
    return request({
        url: '/api/produce/transport-plan/selectM/page',
        method: 'post',
        data: withTruckInboundType({ planType: 2, ...row })
    })
}

export const planSummary = (row) => {
    return request({
        url: '/api/produce/transport-plan/selectPlanSummary',
        method: 'post',
        data: withTruckInboundType({ planType: 2, ...row })
    })
}

export const pycode = (row) => {
    return request({
        url: '/api/produce/vardict/select/distinct/pycode',
        method: 'get',
        params: row
    })
}

export const getCustNoList = (row) => {
    return request({
        url: '/api/produce/blade-dept/select/distinct/select',
        method: 'get',
        params: row
    })
}

export const getSysParamPage = (row) => {
    return request({
        url: '/api/blade-system/param/list',
        method: 'get',
        params: {
            current: row.current || row.page || 1,
            size: row.size || 10,
            paramKey: row.paramKey || row.paramName
        }
    })
}
